module.exports = __webpack_public_path__ + "static/media/flexi_szlahu_color.6d03f064.svg";